const _standardErrorMessage =
  "Something interrupted that action and it wasn't completed. Please try again in a moment. If the problem continues, contact your administrator.";
export const ERROR_MESSAGE_MAPPER: Map<number, string> = new Map([
  [500, _standardErrorMessage],
  [0, _standardErrorMessage],
]);

export const fetchErrorMessage = (
  errorStatus: number,
  incomingError: string | null,
) => {
  if (incomingError) {
    return incomingError;
  }
  return `${ERROR_MESSAGE_MAPPER.get(errorStatus)}`;
};
